import { printHidden } from '@/lib/shared/styles/print';
import { cn } from '@/lib/shared/ui';
import Link from 'next/link';
import React from 'react';

type Props = {
  activeLink?: 'account' | 'licenses' | 'transactions' | 'invoices';
};

const links = [
  {
    href: '/account/',
    label: 'Account Home',
    key: 'account',
  },
  {
    href: '/account/licenses/',
    label: 'Licenses',
    key: 'licenses',
  },
  {
    href: '/account/transactions/',
    label: 'Transaction History',
    key: 'transactions',
  },
  {
    href: '/account/invoices/',
    label: 'Invoices',
    key: 'invoices',
  },
];

const highlightedClasses = 'bg-background-light text-background-color';

export default (props: Props) => (
  <nav className={cn('flex gap-3', printHidden)}>
    {links.map((link) => (
      <Link
        key={link.key}
        className={cn(
          'p-5 py-4 text-sm rounded hover:bg-background-light hover:text-background-color',
          props.activeLink === link.key ? highlightedClasses : '',
        )}
        href={link.href}
      >
        {link.label}
      </Link>
    ))}
  </nav>
);
